var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyscale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.542 0A.542.542 0 000 .542v11.916c0 .299.243.542.542.542h11.916a.542.542 0 00.542-.542V.542A.542.542 0 0012.458 0H.542zm.541 1.083h1.215L1.083 2.298V1.083zm2.747 0h1.532L1.083 5.362V3.83L3.83 1.083zm3.064 0h1.533L1.083 8.427V6.894l5.811-5.811zm3.064 0h1.532L1.083 11.49V9.958l8.875-8.875z"
  })));
}
export default SvgGreyscale;